#import "../../../../graphql/fragments/sales-automation-stageset.graphql"

mutation UpdateClosedLeadFollowupAutomation($input: FollowupLeadAutomationUpdateInput!) {
    followupLeadAutomationUpdate(input: $input) {
        stageset {
            ...SalesAutomationStageset
        }
    }
}
